import React, {FC} from 'react';
import './style.scss';
import BaseButton from '../../form/Button';
import {useHistory} from "react-router-dom";
import classNames from "classnames";
import {IS_PLATFORM_IOS} from "../../../services/utils/platforms";

interface INoMixesPreference {

}

const NoMixesPreference: FC<INoMixesPreference> = () => {
    const history = useHistory();

    const clickHandler = () => {
        history.push(`/main/change-pref/tastes`);
    };

    return (
        <div className={classNames({
            "no-mixes": true,
            "no-mixes--ios": IS_PLATFORM_IOS
        })}>
            <div className="no-mixes__container">
                <div className="no-mixes__title">
                    Мы не смогли найти миксы по вашим предпочтениям
                </div>
                <div className="no-mixes__button">
                    <BaseButton
                        onClick={clickHandler}
                        isGreenButton
                        withBorderRadius
                        sizePadding="9px 25px"
                    >
                        <span className="no-mixes__button-text"> Изменить предпочтения</span>
                    </BaseButton>
                </div>
            </div>
        </div>
    )
};

export default NoMixesPreference;
